"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const redux_1 = require("redux");
const actions_1 = require("~/store/actions");
const selectors_1 = require("~/store/selectors");
const types_1 = require("~/store/types");
const CatalogCategory_1 = __importDefault(require("../CatalogCategory"));
const CatalogChips_1 = __importDefault(require("../CatalogChips"));
const CatalogGroup_1 = require("../CatalogGroup");
const CatalogLoading_1 = __importDefault(require("../CatalogLoading"));
const CatalogTabs_1 = __importDefault(require("../CatalogTabs"));
const CatalogTile_1 = require("../CatalogTile");
const Catalog_module_scss_1 = __importDefault(require("./Catalog.module.scss"));
function Catalog() {
    const { isLoading: isCatalogLoading } = (0, react_redux_1.useSelector)(selectors_1.selectCatalog);
    const { isLoading: isCatalogMetaLoading } = (0, react_redux_1.useSelector)(selectors_1.selectCatalogMeta);
    const categoryGroups = (0, react_redux_1.useSelector)(selectors_1.selectCatalogGroupsWithItems);
    const currentCategoryGroup = (0, react_redux_1.useSelector)(selectors_1.selectCatalogCategoryGroup);
    const { dispatchSetCatalogCategoryGroup } = (0, redux_1.bindActionCreators)({
        dispatchSetCatalogCategoryGroup: actions_1.setCatalogCategoryGroup,
        dispatchSetCatalogCategory: actions_1.setCatalogCategory,
    }, (0, react_redux_1.useDispatch)());
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    (0, react_1.useEffect)(() => {
        setIsLoading(isCatalogLoading === types_1.LOADING_STATE.LOADING || isCatalogMetaLoading === types_1.LOADING_STATE.LOADING);
    }, [isCatalogLoading, isCatalogMetaLoading]);
    const categoryClickHandler = (value) => {
        dispatchSetCatalogCategoryGroup(value);
    };
    if (isLoading) {
        return react_1.default.createElement(CatalogLoading_1.default, null);
    }
    return (react_1.default.createElement("div", { className: Catalog_module_scss_1.default.content },
        react_1.default.createElement(CatalogTabs_1.default, null),
        react_1.default.createElement(CatalogChips_1.default, null),
        categoryGroups && !currentCategoryGroup && (react_1.default.createElement(CatalogGroup_1.CatalogGroup, null, categoryGroups.map((categoryGroup) => {
            var _a;
            return (react_1.default.createElement(CatalogTile_1.CatalogTile, { key: categoryGroup.name, id: categoryGroup.id, imageURI: (_a = categoryGroup.image) === null || _a === void 0 ? void 0 : _a.url, label: categoryGroup.name, onClick: categoryClickHandler, value: categoryGroup }));
        }))),
        currentCategoryGroup ? react_1.default.createElement(CatalogCategory_1.default, null) : null));
}
exports.default = Catalog;
